import React, { useState } from "react";

const CategoryForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors = {}, // Added errors prop to display validation messages
}) => {
  const [formData, setFormData] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({}); // Validation errors
  
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const validate = () => {
    const validationErrors = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const onlyTextRegex = /^[A-Za-z\s-]+$/;

    if (!formData.name.trim()) {
      validationErrors.name = "Name is required.";
    } else if (!onlyTextRegex.test(formData.name.trim())) {
      validationErrors.name = "Name should contain only letters and spaces.";
    }

    if (!formData.description.trim()) {
      validationErrors.description = "Description is required.";
    } else if (!onlyTextRegex.test(formData.description.trim())) {
      validationErrors.description = "Description should contain only letters and spaces.";
    }

    return validationErrors;
  };


  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setFormErrors(validationErrors);
      return;
    }	

    setFormErrors("")

    const submissionData = new FormData(); // Use FormData for file upload
    submissionData.append("name", formData.name);
    submissionData.append("description", formData.description);
    submissionData.append("is_active", formData.is_active ? 1 : 0);

    onSubmit(submissionData); // Pass the FormData to the parent onSubmit handler
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Name Field */}
      <div>
        <label htmlFor="name" className="block dark:text-white text-sm font-medium text-gray-700">
          Name <span className="text-red-500 ml-1">*</span>
        </label>
        <input
          type="text"
          id="name"
          name="name"
          value={formData.name}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.name ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {formErrors.name && <p className="text-red-500 text-sm mt-1">{formErrors.name}</p>}
      </div>

      {/* Description Field */}
      <div>
        <label htmlFor="description" className="block dark:text-white text-sm font-medium text-gray-700">
          Description <span className="text-red-500 ml-1">*</span>
        </label> 
        <textarea
          type="text"
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
            formErrors.description ? "border-red-500" : "border-gray-300"
          }`}
          required
        />
        {formErrors.description && <p className="text-red-500 text-sm mt-1">{formErrors.description}</p>}
      </div>

      {/* Is Active Field */}
      <div className="flex items-center">
          <input
          type="checkbox"
          id="is_active"
          name="is_active"
          checked={formData.is_active}
          onChange={handleChange}
          className="h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          />
          <label htmlFor="is_active" className="ml-2 block text-sm font-medium text-gray-700 dark:text-white">
          Is Active
          </label>
      </div>

      {/* Form Actions */}
      <div className="flex justify-end items-center gap-2">
        <button
          type="button"
          onClick={closeModal}
          className="px-6 py-2 font-medium text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="flex items-center gap-2 px-8 py-2 font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          {initialValues.id ? "Update" : "Add"}
          {loading && (
            <svg
              className="animate-spin h-5 w-5 ml-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
              ></path>
            </svg>
          )}
        </button>
      </div>
    </form>
  );
};

export default CategoryForm;
